import type { BeforeRequestHook } from "ky";

// Restore Axios-era behavior: POST/PUT/PATCH with no body sends {} rather than nothing.
// With Axios, an omitted or undefined body was always serialized as "{}".
// With ky, json: undefined produces a body-less request (Content-Length: 0), which
// causes backends that call request.body.keys() to throw AttributeError on NoneType.
export const emptyBodyHook: BeforeRequestHook = ({ request }) => {
  if (!["POST", "PUT", "PATCH"].includes(request.method) || request.body !== null) {
    return undefined;
  }

  const headers = new Headers(request.headers);

  headers.set("Content-Type", "application/json");

  // oxlint-disable-next-line unicorn/no-invalid-fetch-options -- method is guaranteed POST/PUT/PATCH by the guard above
  return new Request(request, { body: "{}", headers });
};
